import React from "react";
import styles from "../../lib/Common/commonStyles";
import { useTranslation } from "react-i18next";
import Header from "../../lib/Common/Header";
import Footer from "../../lib/Common/Footer";

const OrderConfirmation = ({
  setStep,
  setValues,
  values,
  formData,
  setFormData,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Header contract={true}></Header>{" "}
      <div className="d-flex align-items-center justify-content-center  backgroundColorCommon min-vh-100">
        <div className="text-center text-white px-4 px-md-4 ">
          <img
            src={require("../../assets/images/thankyou-mail.png")}
            height={250}
            width={250}
          />

          <h1 className="mb-2 mb-md-4 fontSize48Bold textGreen">
            {t("Thank you for your order!")}
          </h1>

          <p className="mb-2 mb-md-4 text-white fontSize32Regular lineHeight38">
            {t("It’s great to have you on board.")}
          </p>

          <p className="mb-2 mb-md-5 lh-base text-white fontSize32Regular lineHeight38">
            {t("We’ve sent the details of your order to")}
            <br />
            {formData?.personalInformation?.email || values?.email}
          </p>

          <button
            type="submit"
            onClick={() => {
              setValues({});
              setFormData({});
              setStep(0);
            }}
            className="text-blue fontSize16Medium backgroundColorPink next-button-responsive-success mt-3"
            onMouseOver={(e) => (e.target.style.backgroundColor = "#B24BF3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#FF53FF")}
          >
            {t("Back to the Homepage")}
          </button>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default OrderConfirmation;
